import cx from 'classnames';
import type { FunctionComponent } from 'react';

type Props = {
  /**
   * Optional className if you need to override the CSS.
   * Ideally you should not need to use this, as it leads
   * to <List> looking different in different parts of the app.
   */
  className?: string;

  /**
   * Optional data-test-id for selenium hooks.
   */
  testId?: string;

  /**
   * If the list should be borderless
   */
  isBorderless?: boolean;
};

/**
 * List is the top-level list wrapper component.
 * Allows you to customize the style a bit with a className,
 * however ideally you should not need this.
 */
const List: FunctionComponent<Props> = ({ children, className, testId, isBorderless }) => (
  <div className={cx('fossa-list', className, { 'fossa-list--borderless': isBorderless })} data-test-id={testId}>
    {children}
  </div>
);

export default List;
